<div class="content-card">
    <div class="map-container">
        <div class="map-frame">
            <div id="map">
                <div mat-dialog-actions align="end">
                    <div style="position: relative; z-index: 9999; padding: 5px;" fxLayout="column"
                        fxLayoutAlign="end end">
                        <button *ngIf="markerOpen==false" matTooltip="{{'CONFIRM_LOCATION'|translate}}" mat-raised-button
                            style="margin-bottom: 10px;" (click)="onAddLocationClick($event)">
                            {{'CONFIRM_LOCATION'|translate}}
                        </button>
                        <button matTooltip="Konumu Seç" mat-raised-button style="margin-bottom: 10px;"
                            (click)="onUpdateLocationClick($event)">
                            {{'SELECT_LOCATION'|translate}}
                        </button>
                        <button matTooltip="İşaretlemeyi Kapat" *ngIf="markerOpen" mat-raised-button
                            (click)="onCancelLocationClick($event)">
                            <mat-icon>clear</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>